// @flow
import * as React from 'react'

import { colors } from '@toggl/style'

export const IconPswHidden = ({
  color = colors.beige,
  height = 20,
  width = 20,
}: {
  color?: string,
  height?: number,
  width?: number,
}) => (
  <svg width={width} height={height} fill={color} viewBox="0 0 20 20">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="_Icons-/-View-Copy-2">
        <g id="_Icons-/-Link-/-Neutral">
          <polygon id="Shape" points="0 0 20 0 20 20 0 20"></polygon>
        </g>
        <path
          d="M16.363961,2.22182541 L17.7781746,3.63603897 L15.6248161,5.79019785 C16.9432806,6.78164931 18.0683419,8.18491669 19,10 C17.1000377,14 14.1142326,16 10.0425847,16 C8.61583918,16 7.31893523,15.7544259 6.15187284,15.2632777 L3.63603897,17.7781746 L2.22182541,16.363961 L16.363961,2.22182541 Z M14.3669722,7.04781 L12.8576789,8.55844023 C13.0766458,8.99165481 13.2,9.48142194 13.2,10 C13.2,11.7673112 11.7673112,13.2 10,13.2 C9.48142194,13.2 8.99165481,13.0766458 8.55844023,12.8576789 L7.54939639,13.8657662 C8.31185352,14.0885887 9.13976186,14.2 10.0331214,14.2 C13.1999587,14.2 15.5222516,12.8 17,10 C16.2735205,8.72618653 15.3958446,7.7421232 14.3669722,7.04781 Z M10.0227494,4 C10.8320401,4 11.6015347,4.0847386 12.331233,4.2542158 L10.756979,5.82837841 C10.5154868,5.80945947 10.2690585,5.8 10.017694,5.8 C6.9597153,5.8 4.62048397,7.2 3,10 C3.43764386,10.8051741 3.94329889,11.4945794 4.51696507,12.0682159 L3.28108717,13.3050276 C2.40570457,12.4208937 1.64534218,11.3192178 1,10 C3.08347938,6 6.09106252,4 10.0227494,4 Z M9.77618141,6.80770559 L6.80770559,9.77618141 C6.91748738,8.18723909 8.18723909,6.91748738 9.77618141,6.80770559 Z"
          id="Combined-Shape"
          fill="#7E6E85"
        ></path>
      </g>
    </g>
  </svg>
)
